import React from "react";

import classNames from "classnames";

type AccountStatementPagerButtonProps = {
	disabled?: boolean;
	page: number;
	active?: boolean;
	children?: JSX.Element | JSX.Element | string | number;
	onPageChange: (newPage: number) => void;
};

export default function AccountStatementPagerButton(
	props: AccountStatementPagerButtonProps
) {
	const itemClasses = classNames(
		"pagination__item btn btn--square btn--square--sml",
		{
			"btn--primary--inverted": !props.active,
			"btn--primary is-active": props.active,
		}
	);

	return (
		<button
			type="button"
			className={itemClasses}
			disabled={props.disabled}
			onClick={() => {
				props.onPageChange(props.page);
			}}
		>
			{props.children}
		</button>
	);
}
